const elmar = require("./images/elmar_matanato.png")
const googleBusiness = require("./images/Google-Business-Profiile-Rating.jpeg")

const About = () => {
    return (
        <section className="py-14">
            <div className="grid md:grid-cols-2 max-w-screen-xl mx-auto px-4 md:px-8">
                <div className="max-w-3xl mx-auto">
                    <figure>
                        <blockquote>
                            <p className="text-gray-800 text-xl text-center font-semibold sm:text-2xl">
                                “At <span className="font-bold">MATANATO</span>, we deliver trust and quality in every service, ensuring top-notch care for your home. Our commitment to excellence has earned us a reputation for reliability and happy clients who trust us with their homes.“
                            </p>
                        </blockquote>
                        <div className="flex justify-center items-center gap-x-4 mt-6">
                            <img src={elmar} className="h-24 rounded-full" alt="elmar-matanato-founder"/>
                            <div>
                                <span className="block text-gray-800 font-semibold">Elmar A.S.</span>
                                <span className="block text-gray-600 text-sm mt-0.5">Founder of MATANATO</span>
                            </div>
                        </div>
                    </figure>
                </div>
                <div class="mt-4 md:mt-0 max-w-md mx-auto bg-white shadow-lg rounded-xl p-6 text-center border border-gray-200">
    <img src={googleBusiness} alt="Google Business Profile" class="w-full rounded-lg mb-4 shadow-lg w-24" />
    <h2 class="text-xl font-semibold text-gray-800">Find Us on Google</h2>
    <p class="text-gray-600 mt-2">We’re proud to be on Google Business Profile, building trust with our happy clients. Check our reviews and location!</p>
    <a href="https://g.co/kgs/Si1AVa7" target="_blank" class="mt-4 inline-block bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition">
        View on Google
    </a>
</div>


            </div>
        </section>
    )
}

export default About;

